import * as Yup from "yup";
import {
  ABROAD_BIRTH_PLACE_ID,
  AMKA_LENGTH,
  FIELD_IS_REQUIRED,
  FIELD_MUST_BE_ELEVEN_DIGITS,
  FIELD_MUST_BE_ONLY_NUMBERS,
  ISSUE_COPY_NAUTICAL,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_MUST_BE_10_DIGITS,
  NEW_NAUTICAL_APPLICATION,
  PHONE_NUMBER_LENGTH,
  PHONE_NUMBER_MUST_BE_10_DIGITS,
  POSTAL_CODE_LENGTH,
  POSTAL_CODE_MUST_BE_5_DIGITS,
  REQUIRED_DOCUMENTS_MISSING,
  RESIGN_NAUTICAL,
} from "../../../../constants";
import toposEggrafisDimotologiouValidate from "./toposEggrafisDimotologiouValidate";
import validateDocuments from "./validateDocuments";

import birthPlaceNotGreeceValidate from "./birthPlaceNotGreeceValidate";

function validationSchemaForMe(id, t, docsPerKindFiltered, nauticalPdColor) {
  return Yup.object().shape(
    {
      portAuthority: Yup.object().required(t(FIELD_IS_REQUIRED)),
      appl_kind_id: Yup.number().required(t(FIELD_IS_REQUIRED)),
      dt_birth_afora: Yup.date().nullable().required(t(FIELD_IS_REQUIRED)),
      lname_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      fname_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      email_afora: Yup.string()
        .email(t("Invalid email"))
        //   .required(t(FIELD_IS_REQUIRED))
        .nullable(),
      status: Yup.number().required(t(FIELD_IS_REQUIRED)),
      documents: Yup.array().test(
        "includes-required",
        t(REQUIRED_DOCUMENTS_MISSING),
        function (documents) {
          return validateDocuments(
            documents,
            docsPerKindFiltered,
            this.parent.status
          );
        }
      ),
      amka_afora: Yup.string()
        .required(t("Field is required"))
        .nullable()
        .min(11, t("Field must be 11 digits"))
        .max(11, t("Field must be 11 digits")),
      fath_fname_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      fath_lname_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      moth_lname_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      moth_fname_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      ind_nr_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      place_birth_afora: Yup.object().required(t(FIELD_IS_REQUIRED)).nullable(),
      dimos_diamonis_afora: Yup.object()
        .required(t(FIELD_IS_REQUIRED))
        .nullable()
        .shape({
          id: Yup.string().required(t(FIELD_IS_REQUIRED)),
        }),
      topos_eggrafis_dimotologiou_ellada: Yup.string().test(
        "required",
        t(FIELD_IS_REQUIRED),
        toposEggrafisDimotologiouValidate
      ),
      address_afora: Yup.string().required(t(FIELD_IS_REQUIRED)).nullable(),
      address_nr_afora: Yup.string().required(t(FIELD_IS_REQUIRED)).nullable(),

      tel_afora: Yup.string()
        //   .required(t("Field is required"))
        .nullable()
        .min(10, t("Phone number must be 10 digits"))
        .max(10, t("Phone number must be 10 digits")),
      mobile_afora: Yup.string()
        //   .required(t("Field is required"))
        .nullable()
        .min(10, t("Mobile number must be 10 digits"))
        .max(10, t("Mobile number must be 10 digits")),
      meth_afora:
        id !== NEW_NAUTICAL_APPLICATION
          ? Yup.string().required(t(FIELD_IS_REQUIRED))
          : Yup.string().nullable(),
      tk_afora: Yup.number()
        .typeError(t(FIELD_MUST_BE_ONLY_NUMBERS))
        .required(t(FIELD_IS_REQUIRED))
        .test(
          "len",
          t(POSTAL_CODE_MUST_BE_5_DIGITS),
          (val) => parseInt(val).toString().length === POSTAL_CODE_LENGTH
        ),
      sintaksiouxos_afora:
        parseInt(id) !== ISSUE_COPY_NAUTICAL && nauticalPdColor === "blue"
          ? Yup.string().required(t(FIELD_IS_REQUIRED))
          : Yup.object().nullable(),

      epipedo_ekpaideusis_afora:
        id === NEW_NAUTICAL_APPLICATION
          ? Yup.object()
              .required(t(FIELD_IS_REQUIRED))
              .nullable()
              .shape({
                id: Yup.string().required(t(FIELD_IS_REQUIRED)),
              })
          : Yup.object().nullable(),
      gender_afora: Yup.object().required(t(FIELD_IS_REQUIRED)).nullable(),
      nationality_afora: Yup.string().required(t(FIELD_IS_REQUIRED)),
      read_dilosi_idiotiton:
        id === NEW_NAUTICAL_APPLICATION
          ? Yup.bool()
              .required(t(FIELD_IS_REQUIRED))
              .oneOf([true], t("Field must be checked"))
          : Yup.object().nullable(),
      reason_for_copy_nautical_issue:
        id == ISSUE_COPY_NAUTICAL
          ? Yup.string().required(t(FIELD_IS_REQUIRED))
          : Yup.object().nullable(),
      birth_country: Yup.object().required(t(FIELD_IS_REQUIRED)).nullable(),
      birth_city_not_greece: Yup.string().test(
        "required",
        t(FIELD_IS_REQUIRED),
        birthPlaceNotGreeceValidate
      ),
    },
    ["tel_afora", "tel_afora"]
  );
}

export default validationSchemaForMe;
